export default "/images/logo_wings.svg?0b82dc6a475868441e394b12a61ddcfb";